import { render, staticRenderFns } from "./ChatBoxLocation.vue?vue&type=template&id=5f344550&scoped=true&"
import script from "./ChatBoxLocation.vue?vue&type=script&lang=js&"
export * from "./ChatBoxLocation.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxLocation.vue?vue&type=style&index=0&id=5f344550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f344550",
  null
  
)

export default component.exports